import DatatypeField from "./DatatypeField";

export default DatatypeField;
